/**
 * mediumApi.js
 * ------------
 * API client for Medium Master using createMasterApiClient.
 * Connects directly to FastAPI backend /medium/ endpoints.
 */
import { createMasterApiClient } from '../../common/masterApiFactory';

export const mediumClient = createMasterApiClient('medium');
export default mediumClient;

export async function listMediums(params = {}) {
  return await mediumClient.list(params);
}

export async function getMediumDetail(mediumId) {
  return await mediumClient.getById(mediumId);
}

export async function createMedium(payload) {
  return await mediumClient.create(payload);
}

export async function updateMedium(mediumId, payload) {
  return await mediumClient.update(mediumId, payload);
}

export async function archiveMedium(mediumId) {
  return await mediumClient.archive(mediumId);
}

export async function deleteMedium(mediumId) {
  return await mediumClient.remove(mediumId);
}

export async function getMediumOptions() {
  return await mediumClient.getDropdownOptions();
}
